module.exports = __webpack_public_path__ + "static/media/audits_large.4adfa71e.jpg";